const CheckEmail = (str) => {
    if (!str || typeof str != 'string' || str.length <= 10) return false;
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return regex.test(str);
}

export default CheckEmail;